import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../services/user';
import { SpinService } from '../../../../services/spinservice';


@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})

export class HomepageComponent implements OnInit {
  contentReady: boolean = false;

  showWheel = false;
  userId!: any;
  constructor(
    private userService: UserService,
    private spinService: SpinService) {

  }

  ngOnInit(): void {

    this.userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data.user_id;
        this.checkWheel();
      },
      error: () => {
        // 👇 ده guest
        this.userId = null as any;
        this.checkWheel(); // لازم تناديها هنا
      }
    });

  }

  checkWheel() {

    this.spinService.getActive(this.userId ?? null)
      .subscribe(res => {

        this.showWheel =
          !res.active_reward &&
          res.preview_products?.length > 0;

        this.contentReady = false;
      });

  }





}
